/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BasicLoanInfo,
  CustomerLoanInformationDTO,
  CustomerLoanRequest,
  GetBasicLoanInfoParams,
  GetCustomerLoanInformationParams,
  GetLoanSummaryParams,
  GetMultipleCustomersLoanInformationParams,
  GetPaymentHistoryParams,
  GetUpcomingPaymentsParams,
  LoanSummaryDTO,
  PaymentHistory,
  ScheduledPayment
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getMultipleCustomersLoanInformation = (
    customerLoanRequest: CustomerLoanRequest[],
    params?: GetMultipleCustomersLoanInformationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerLoanInformationDTO[]>(
      {url: `/api/customer-loans/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerLoanRequest,
        params, signal
    },
      options);
    }
  


export const getGetMultipleCustomersLoanInformationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>, TError,{data: CustomerLoanRequest[];params?: GetMultipleCustomersLoanInformationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>, TError,{data: CustomerLoanRequest[];params?: GetMultipleCustomersLoanInformationParams}, TContext> => {

const mutationKey = ['getMultipleCustomersLoanInformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>, {data: CustomerLoanRequest[];params?: GetMultipleCustomersLoanInformationParams}> = (props) => {
          const {data,params} = props ?? {};

          return  getMultipleCustomersLoanInformation(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetMultipleCustomersLoanInformationMutationResult = NonNullable<Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>>
    export type GetMultipleCustomersLoanInformationMutationBody = CustomerLoanRequest[]
    export type GetMultipleCustomersLoanInformationMutationError = unknown

    export const useGetMultipleCustomersLoanInformation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>, TError,{data: CustomerLoanRequest[];params?: GetMultipleCustomersLoanInformationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getMultipleCustomersLoanInformation>>,
        TError,
        {data: CustomerLoanRequest[];params?: GetMultipleCustomersLoanInformationParams},
        TContext
      > => {

      const mutationOptions = getGetMultipleCustomersLoanInformationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCustomerLoanInformation = (
    branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerLoanInformationDTO>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCustomerLoanInformationInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetCustomerLoanInformationParams,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetCustomerLoanInformationQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetCustomerLoanInformationParams,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomerLoanInformationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLoanInformation>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLoanInformationInfiniteQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLoanInformation>>> = ({ signal }) => getCustomerLoanInformation(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLoanInformationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLoanInformation>>>
export type GetCustomerLoanInformationInfiniteQueryError = unknown


export function useGetCustomerLoanInformationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLoanInformation>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetCustomerLoanInformationParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLoanInformation>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLoanInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLoanInformationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLoanInformation>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLoanInformation>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLoanInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLoanInformationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLoanInformation>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCustomerLoanInformationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLoanInformation>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLoanInformationInfiniteQueryOptions(branch,custNo,glNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerLoanInformationQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLoanInformationQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLoanInformation>>> = ({ signal }) => getCustomerLoanInformation(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLoanInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLoanInformation>>>
export type GetCustomerLoanInformationQueryError = unknown


export function useGetCustomerLoanInformation<TData = Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetCustomerLoanInformationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLoanInformation>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLoanInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLoanInformation<TData = Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLoanInformation>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLoanInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLoanInformation<TData = Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCustomerLoanInformation<TData = Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetCustomerLoanInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLoanInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLoanInformationQueryOptions(branch,custNo,glNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUpcomingPayments = (
    branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduledPayment[]>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}/upcoming-payments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUpcomingPaymentsInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetUpcomingPaymentsParams,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}/upcoming-payments`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetUpcomingPaymentsQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetUpcomingPaymentsParams,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}/upcoming-payments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUpcomingPaymentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUpcomingPayments>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpcomingPaymentsInfiniteQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingPayments>>> = ({ signal }) => getUpcomingPayments(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUpcomingPaymentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingPayments>>>
export type GetUpcomingPaymentsInfiniteQueryError = unknown


export function useGetUpcomingPaymentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpcomingPayments>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetUpcomingPaymentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingPayments>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUpcomingPaymentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpcomingPayments>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingPayments>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUpcomingPaymentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpcomingPayments>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUpcomingPaymentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpcomingPayments>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUpcomingPaymentsInfiniteQueryOptions(branch,custNo,glNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUpcomingPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getUpcomingPayments>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpcomingPaymentsQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingPayments>>> = ({ signal }) => getUpcomingPayments(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUpcomingPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingPayments>>>
export type GetUpcomingPaymentsQueryError = unknown


export function useGetUpcomingPayments<TData = Awaited<ReturnType<typeof getUpcomingPayments>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetUpcomingPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingPayments>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUpcomingPayments<TData = Awaited<ReturnType<typeof getUpcomingPayments>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingPayments>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUpcomingPayments<TData = Awaited<ReturnType<typeof getUpcomingPayments>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUpcomingPayments<TData = Awaited<ReturnType<typeof getUpcomingPayments>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetUpcomingPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUpcomingPaymentsQueryOptions(branch,custNo,glNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLoanSummary = (
    branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanSummaryDTO>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}/summary`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoanSummaryInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetLoanSummaryParams,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}/summary`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoanSummaryQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetLoanSummaryParams,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}/summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanSummaryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanSummary>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanSummaryInfiniteQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanSummary>>> = ({ signal }) => getLoanSummary(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanSummary>>>
export type GetLoanSummaryInfiniteQueryError = unknown


export function useGetLoanSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanSummary>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetLoanSummaryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanSummary>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanSummary>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoanSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanSummary>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanSummaryInfiniteQueryOptions(branch,custNo,glNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLoanSummary>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanSummaryQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanSummary>>> = ({ signal }) => getLoanSummary(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanSummary>>>
export type GetLoanSummaryQueryError = unknown


export function useGetLoanSummary<TData = Awaited<ReturnType<typeof getLoanSummary>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetLoanSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanSummary<TData = Awaited<ReturnType<typeof getLoanSummary>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanSummary<TData = Awaited<ReturnType<typeof getLoanSummary>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoanSummary<TData = Awaited<ReturnType<typeof getLoanSummary>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetLoanSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanSummaryQueryOptions(branch,custNo,glNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPaymentHistory = (
    branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentHistory>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}/payment-history`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPaymentHistoryInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetPaymentHistoryParams,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}/payment-history`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPaymentHistoryQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetPaymentHistoryParams,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}/payment-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentHistoryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPaymentHistory>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentHistoryInfiniteQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentHistory>>> = ({ signal }) => getPaymentHistory(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaymentHistoryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentHistory>>>
export type GetPaymentHistoryInfiniteQueryError = unknown


export function useGetPaymentHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPaymentHistory>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetPaymentHistoryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPaymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPaymentHistory>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPaymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPaymentHistory>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaymentHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPaymentHistory>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaymentHistoryInfiniteQueryOptions(branch,custNo,glNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaymentHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentHistory>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentHistoryQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentHistory>>> = ({ signal }) => getPaymentHistory(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaymentHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentHistory>>>
export type GetPaymentHistoryQueryError = unknown


export function useGetPaymentHistory<TData = Awaited<ReturnType<typeof getPaymentHistory>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetPaymentHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPaymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentHistory<TData = Awaited<ReturnType<typeof getPaymentHistory>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPaymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentHistory<TData = Awaited<ReturnType<typeof getPaymentHistory>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaymentHistory<TData = Awaited<ReturnType<typeof getPaymentHistory>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetPaymentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaymentHistoryQueryOptions(branch,custNo,glNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const hasActiveLoan = (
    branch: string,
    custNo: string,
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}/has-active-loan`, method: 'GET', signal
    },
      options);
    }
  



export const getHasActiveLoanInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}/has-active-loan`
    ] as const;
    }

export const getHasActiveLoanQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}/has-active-loan`
    ] as const;
    }

    
export const getHasActiveLoanInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hasActiveLoan>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasActiveLoanInfiniteQueryKey(branch,custNo,glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasActiveLoan>>> = ({ signal }) => hasActiveLoan(branch,custNo,glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasActiveLoanInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hasActiveLoan>>>
export type HasActiveLoanInfiniteQueryError = unknown


export function useHasActiveLoanInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasActiveLoan>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasActiveLoan>>,
          TError,
          Awaited<ReturnType<typeof hasActiveLoan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasActiveLoanInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasActiveLoan>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasActiveLoan>>,
          TError,
          Awaited<ReturnType<typeof hasActiveLoan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasActiveLoanInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasActiveLoan>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasActiveLoanInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasActiveLoan>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasActiveLoanInfiniteQueryOptions(branch,custNo,glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHasActiveLoanQueryOptions = <TData = Awaited<ReturnType<typeof hasActiveLoan>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasActiveLoanQueryKey(branch,custNo,glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasActiveLoan>>> = ({ signal }) => hasActiveLoan(branch,custNo,glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasActiveLoanQueryResult = NonNullable<Awaited<ReturnType<typeof hasActiveLoan>>>
export type HasActiveLoanQueryError = unknown


export function useHasActiveLoan<TData = Awaited<ReturnType<typeof hasActiveLoan>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasActiveLoan>>,
          TError,
          Awaited<ReturnType<typeof hasActiveLoan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasActiveLoan<TData = Awaited<ReturnType<typeof hasActiveLoan>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasActiveLoan>>,
          TError,
          Awaited<ReturnType<typeof hasActiveLoan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasActiveLoan<TData = Awaited<ReturnType<typeof hasActiveLoan>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasActiveLoan<TData = Awaited<ReturnType<typeof hasActiveLoan>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasActiveLoan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasActiveLoanQueryOptions(branch,custNo,glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBasicLoanInfo = (
    branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BasicLoanInfo>(
      {url: `/api/customer-loans/${branch}/${custNo}/${glNo}/basic`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetBasicLoanInfoInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetBasicLoanInfoParams,) => {
    return [
    'infinite', `/api/customer-loans/${branch}/${custNo}/${glNo}/basic`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetBasicLoanInfoQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    params?: GetBasicLoanInfoParams,) => {
    return [
    `/api/customer-loans/${branch}/${custNo}/${glNo}/basic`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBasicLoanInfoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBasicLoanInfo>>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasicLoanInfoInfiniteQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasicLoanInfo>>> = ({ signal }) => getBasicLoanInfo(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBasicLoanInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBasicLoanInfo>>>
export type GetBasicLoanInfoInfiniteQueryError = unknown


export function useGetBasicLoanInfoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBasicLoanInfo>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetBasicLoanInfoParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasicLoanInfo>>,
          TError,
          Awaited<ReturnType<typeof getBasicLoanInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBasicLoanInfoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBasicLoanInfo>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasicLoanInfo>>,
          TError,
          Awaited<ReturnType<typeof getBasicLoanInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBasicLoanInfoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBasicLoanInfo>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBasicLoanInfoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBasicLoanInfo>>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBasicLoanInfoInfiniteQueryOptions(branch,custNo,glNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetBasicLoanInfoQueryOptions = <TData = Awaited<ReturnType<typeof getBasicLoanInfo>>, TError = unknown>(branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasicLoanInfoQueryKey(branch,custNo,glNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasicLoanInfo>>> = ({ signal }) => getBasicLoanInfo(branch,custNo,glNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBasicLoanInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getBasicLoanInfo>>>
export type GetBasicLoanInfoQueryError = unknown


export function useGetBasicLoanInfo<TData = Awaited<ReturnType<typeof getBasicLoanInfo>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params: undefined |  GetBasicLoanInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasicLoanInfo>>,
          TError,
          Awaited<ReturnType<typeof getBasicLoanInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBasicLoanInfo<TData = Awaited<ReturnType<typeof getBasicLoanInfo>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasicLoanInfo>>,
          TError,
          Awaited<ReturnType<typeof getBasicLoanInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBasicLoanInfo<TData = Awaited<ReturnType<typeof getBasicLoanInfo>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBasicLoanInfo<TData = Awaited<ReturnType<typeof getBasicLoanInfo>>, TError = unknown>(
 branch: string,
    custNo: string,
    glNo: string,
    params?: GetBasicLoanInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasicLoanInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBasicLoanInfoQueryOptions(branch,custNo,glNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




